import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Skeleton, Tooltip } from "@mui/material";
import DateConverter from "@heartinz/date_and_time_processor";
import {
  LoadScript,
  GoogleMap,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import uRLs from "../../../utils/baseUtils";


const ViewInterest = ({
  onClose = () => {},
  isSelectedData,
   
}) => {
  const [isPreLoading, setPreLoading] = useState(true);
  const [selectedMarker, setSelectedMarker] = useState(null);

  const [longitude, latitude] = isSelectedData.location.coordinates;
    var position = {
    lat: latitude,
    lng: longitude
  };
  const mapContainerStyle = {
    width: "100%",
    height: "200px",
    borderRadius: "4px",
  };
const coordinates = `${position.lat},${position.lng}`;
const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(coordinates)}`;


  useEffect(() => {
       setPreLoading(false);
  }, [isSelectedData]);

  
  const DetailItem = ({ iconClass, title, value }) => {
    return (
      <div className="col-lg-4 col-md-6">
        <div className="p-1">
          <div className="d-flex align-items-start gap-3 p-2 rounded">
            <div className="detail-icon fs-5 text-primary">
              <i className={`bx ${iconClass} font-24`}></i>
            </div>
            <div className="detail-info">
              <h6 className="fw-bold text-muted mb-1">{title}</h6>
              <p className="mb-0 fw-bold text-dark">{value}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  
  const LongDetailItem = ({ title, value }) => {
    return (
      <div className="col-12 mt-3">
        <div className="p-3 border rounded">
          <h6 className="fw-bold text-primary mb-2">{title}</h6>
          <p className="mb-0 text-dark" style={{ whiteSpace: "pre-wrap" }}>
            {value}
          </p>
        </div>
      </div>
    );
  };

  const CheckboxDetailItem = ({ title, isChecked }) => {
    return (
      <div className="col-lg-6 col-md-6">
        <div className="p-1">
          <div className="d-flex align-items-center gap-3 p-2 rounded">
            <i
              className={`bx font-24 ${
                isChecked
                  ? "bx-check-circle text-primary"
                  : "bx-x-circle text-danger"
              } fs-4`}
            ></i>

            <div>
              <h6 className="fw-bold text-muted mb-1">{title}</h6>

              <p className="text-dark mb-0 fw-bold font-14">
                {isChecked
                  ? "Stay arrangement provided"
                  : "Stay arrangement not provided"}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

const getStatusDisplayDetails = (s, currentIndex, history) => {
    let color = "#28a745";
    let currentStatusClass = "border-success";
    let icon = "bx-check";
    let statusDisplay = s.status;
      if (s.status === "PENDING" ) { 
         color = "#ffc107"; 
        currentStatusClass = "border-warning";
        icon = "bx-time";
    } else if (s.status === "PAYMENT" && s.paymentCompleted === true) {
         statusDisplay = "PAYMENT COMPLETED";       
    }
 
  
    else if (s.status) {       
        switch (s.status) {
            case "REJECTED":
            case "CANCELLED":
                color = "#dc3545"; 
                currentStatusClass = "border-danger";
                icon = "bx-x";
                statusDisplay = s.status; 
                break;            
            default:            
                break;
        }
    }

    return { color, currentStatusClass, icon, statusDisplay };
};
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show d-block"
        id="BookingModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-xl orderModel">
          <div className="modal-content">
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title">
                Interest Details - <b>{isSelectedData?.interestNumber || isSelectedData?.bookingNumber}</b>
              </h6>

              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body bg-light-background "
              style={{
                overflow: "hidden",
              }}
            >
              <style>
                {`
      @media (max-width: 768px) {
        .modal-body.bg-light-background {
          overflow: auto !important; 
        }
      }
    `}
              </style>
              <div className="">
                <div className="row">
                  <div className="col-md-8 col-sm-12 mb-3">
                    <div className="card mb-0 mt-0 scroll-container rounded-0">
                      <div
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: "10",
                          background: "#fff",
                        }}
                      >                       
                          <button
                            className="accordion-button rounded-start-0  rounded-end-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                          >
                            Interest Info
                          </button>
                       
                      </div>
                      <div className="card-body ">
                        <div className="d-flex justify-content-between">
                            <p className="mb-2 text-left">Interest No: <b>{isSelectedData?.interestNumber || isSelectedData?.bookingNumber}</b></p>
                          <p className="mb-2 text-right">
                                                       <span
                                className={`badge ${
                                  isSelectedData?.lastStatus === "ACCEPTED"
                                    ? "app-badge bg-label-spring":
                                    isSelectedData?.lastStatus === "PLACED"
                                    ? "app-badge bg-label-warning":
                                      isSelectedData?.lastStatus === "PAYMENT"
                                    ? "app-badge bg-label-moon"
                                    : isSelectedData?.lastStatus === "ENQUIRY"
                                    ? "app-badge bg-label-infoss"
                                    : "bg-secondary"
                                }`}
                              >
                                {isSelectedData?.lastStatus === "CREATED"
                                  ? "UnPlaced"
                                  : isSelectedData?.lastStatus === "ENQUIRY"
                                  ? "Enquiry"
                                  : isSelectedData?.lastStatus}
                              </span>
                           
                          </p>
                        </div>

                        <div className="card mb-3">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                          >
                            Work Details
                          </button>

                          <div className="row g-0 align-items-center p-2">
                            <DetailItem
                              iconClass="bx-phone"
                              title="Phone"
                              value={isSelectedData?.mobileNumber || "-"}
                            />
                            <DetailItem
                              iconClass="bx-calendar-event"
                              title="Work Start Date"
                              value={
                                isSelectedData.workStartDate
                                  ? DateConverter.ISOToDisplayFormat(
                                      DateConverter.convertToTimeZone(
                                        isSelectedData.workStartDate,
                                        uRLs.TIMEZONE
                                      )
                                    ).date || ""
                                  : ""
                              }
                            />
                            {isSelectedData.totalPaid > 0 &&(
                            <DetailItem
                              iconClass="bx bx-rupee"
                              title="Amount Paid"
                              value={`₹${isSelectedData.totalPaid} `}
                            />)}
                            <DetailItem
                              iconClass="bx-spa"
                              title="No of Acres"
                              value={`${isSelectedData.numberOfAcres} acres`}
                            />

                            <CheckboxDetailItem
                              iconClass="bx-comment-detail"
                              title="Arrangements"
                              isChecked={isSelectedData?.isArrangement}
                            />
                            <LongDetailItem
                              title="Work Instruction"
                              value={isSelectedData?.workInstruction || "-"}
                            />
                          </div>
                        </div>
                        <div className="card mb-3">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                            fdprocessedid="5b1j1a"
                          >
                            Location{" "}
                          </button>
                          <div className="card-body p-0">
                            <div className="col-12 col-lg-12 d-block  ">
                              <div className="row">
                                <div className="col">
                                  <div className="">
                                    {/* card rounded-4 */}
                                    <div className="row g-0 align-items-center">
                                      <div className="col-lg-7 border-end">
                                       <a 
                                            href={mapUrl} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            link
                                            style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
                                        >
                                        <div className="p-3 align-self-center">
                                          {isPreLoading ? (
                                            <Skeleton
                                              variant="rectangular"
                                              width="100%"
                                              height={200}
                                            />
                                          ) : (
                                            <LoadScript googleMapsApiKey="AIzaSyDco82gO8S8h9fMUUldfkg6HOT3KYZSdfY">
                                              <GoogleMap
                                                mapContainerStyle={
                                                  mapContainerStyle
                                                }
                                                center={position}
                                                zoom={13}
                                              >
                                                <Marker
                                                  position={position}
                                                  onClick={() =>
                                                    setSelectedMarker(position)
                                                  }
                                                />
                                                {selectedMarker && (
                                                  <InfoWindow
                                                    position={selectedMarker}
                                                    onCloseClick={() =>
                                                      setSelectedMarker(null)
                                                    }
                                                  >
                                                    <div>
                                                      <h6>Booking Address</h6>
                                                      <p>
                                                        {
                                                          isSelectedData?.addressLine1
                                                        }
                                                        ,{" "}
                                                        {
                                                          isSelectedData?.addressLine2
                                                        }
                                                        , {isSelectedData.state}
                                                        ,{" "}
                                                        {
                                                          isSelectedData.district
                                                        }
                                                        ,{" "}
                                                        {isSelectedData.country}{" "}
                                                        -{" "}
                                                        {isSelectedData.pincode}
                                                      </p>
                                                    </div>
                                                  </InfoWindow>
                                                )}
                                              </GoogleMap>
                                            </LoadScript>
                                          )}
                                        </div>
                                        </a>
                                      </div>
                                      <div className="col-lg-5">
                                        <div className="card-body">
                                          <div className="d-flex align-items-start gap-3 p-3 rounded">
                                            <div className="detail-icon fs-5">
                                              <i className=" bx bx-location-plus font-24"></i>
                                            </div>
                                            <div className="detail-info">
                                              <h6 className="fw-bold mb-2">
                                                Address
                                              </h6>
                                              <p className="mb-0">
                                                {isSelectedData.addressLine1},{" "}
                                                {isSelectedData.addressLine2},{" "}
                                                {isSelectedData?.state},{" "}
                                                {isSelectedData?.district},{" "}
                                                {isSelectedData?.country} -{" "}
                                                {isSelectedData?.pincode}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-start gap-3 p-3 rounded">
                                            <div className="detail-icon fs-5">
                                              <i className=" bx bx-comment-detail font-24"></i>
                                            </div>
                                            <div className="detail-info">
                                              <h6 className="fw-bold mb-1">
                                                Location Instruction
                                              </h6>
                                              <p className="mb-0">
                                                {
                                                  isSelectedData?.locationInstruction
                                                }
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card mb-0 ">
                         <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                            fdprocessedid="5b1j1a"
                          >
                            Payment{" "}
                          </button>
                          <div className="card-body p-2">                          
                            <div
                              className="product-card"
                              style={{
                                backgroundColor:
                                  isSelectedData?.paymentStatus === "PAID"
                                    ? "#ddfde0"
                                    : isSelectedData?.paymentStatus === "UNPAID"
                                    ? "rgba(13, 110, 253, 0.11)"
                                    : "#f5f5f5",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="p-2">
                                <div className="d-flex justify-content-between">
                                  <h6 className="payment text-muted   mb-2 me-2">
                                    Number of Acres:
                                    <span className="font-16 fw-bold text-dark ms-2">
                                      {isSelectedData?.numberOfAcres || 0} acres
                                    </span>
                                  </h6>
                                  <div className="">
                                    <span
                                      className={`badge ${
                                        isSelectedData?.paymentStatus === "PAID"
                                          ? "bg-label-paid"
                                          : isSelectedData?.paymentStatus ===
                                            "UNPAID"
                                          ? "bg-label-un-paid"
                                          : "bg-label-secondary"
                                      }`}
                                      style={{ marginLeft: "5px" }}
                                    >
                                      {isSelectedData?.paymentStatus ===
                                      "UNPAID"
                                        ? "UnPaid"
                                        : isSelectedData?.paymentStatus ===
                                          "PAID"
                                        ? "Paid"
                                        : isSelectedData?.paymentStatus}
                                    </span>
                                  </div>
                                </div>

                                <div className="mb-2">
                                  <h6 className=" mb-1 text-muted">
                                    Price:{" "}
                                    <span className="font-16 fw-bold text-dark ms-2">
                                      ₹{isSelectedData?.perAcreCost || 0} Per
                                      Acre
                                    </span>
                                  </h6>
                                </div>  
                              
                                 <div className="mb-2 ">
                                  <h6 className=" mb-1 text-muted">
                                    Total Amount:{" "}
                                    <span className="font-16 fw-bold text-green ms-2">
                                      ₹{isSelectedData?.totalAmount}
                                    </span>
                                  </h6>
                                </div>
                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">                 
                      <div className="card mb-0 mt-0 scroll-container">
                        <div
                          style={{
                            position: "sticky",
                            top: "0",
                            zIndex: "10",
                            background: "#fff",
                          }}
                        >
                          <button
                            className="accordion-button rounded-end-0 rounded-start-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                          >
                            Status History
                          </button>
                        </div>
                        <div className="card-body pt-3 pb-1">
                            { (isSelectedData?.statusHistory?.length > 0 ? (isSelectedData?.statusHistory.map((s, index) => {
                                const totalStatuses = isSelectedData?.statusHistory.length;
                               const { color, currentStatusClass, icon, statusDisplay } = getStatusDisplayDetails(s, index, isSelectedData);     
                          
                                const entryByText = s.role || "-";

                                return (
                                    <div key={index} className="d-flex mb-4">
                                        <div className="me-3 d-flex flex-column align-items-center">                   
                                            <div
                                                className={`rounded-circle d-flex align-items-center justify-content-center p-1 border ${currentStatusClass}`}
                                                style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    backgroundColor: color,
                                                    color: "#fff", 
                                                    zIndex: 1,
                                                }}
                                            >
                                                <i className={`bx ${icon} fs-6`}></i>
                                            </div>

                                          
                                            {index < totalStatuses - 1 && (
                                                <div
                                                
                                                    className={`flex-grow-1 border-start border-success`}
                                                    style={{ width: "0", minHeight: "30px" }}
                                                ></div>
                                            )}
                                        </div>
                              
                                        <div
                                            className="p-2 w-100 rounded border"
                                            style={{ backgroundColor: "#f8f9fa", borderLeft: `5px solid ${color}` }}
                                        >
                                           <div className="d-flex justify-content-between align-items-center">
                                            <p
                                                className="fw-bold mb-1"
                                                style={{ color: color }}
                                            >
                                                {statusDisplay}
                                            </p>
                                            {s?.amount &&(
                                               <h6 className=" fw-bold"   style={{ color: color }}>
                                                ₹{s?.amount}                 
                                              </h6> )}
                                            </div>
                                            {/* <p className="small text-muted  mb-1">Interest No:<span className="fw-bold"> {s?.interestNumber}</span></p> */}
                                            <p className="small text-muted  mb-1">
                                                By: <span className="fw-bold">{entryByText}</span>
                                            </p>
                                            <div className="d-flex justify-content-between align-items-center">
                                            <p className="small text-muted mb-1">
                                                <i className="bi bi-calendar-check me-1"></i>
                                                <span className="me-1">                     
                                                    {DateConverter.ISOToDisplayFormat(
                                                        DateConverter.convertToTimeZone(s.time, uRLs.TIMEZONE)
                                                    ).time}
                                                    ,
                                                </span>                 
                                                {DateConverter.ISOToDisplayFormat(
                                                    DateConverter.convertToTimeZone(s.time, uRLs.TIMEZONE)
                                                ).date}
                                            </p>
                                            <span
                                      className={`badge ${
                                        s?.paymentStatus === "PAID"
                                          ? "bg-label-paid"
                                          : s?.paymentStatus ===
                                            "UNPAID"
                                          ? "bg-label-un-paid"
                                          : "bg-label-secondary"
                                      }`}
                                      style={{ marginLeft: "5px" }}
                                    >
                                      {s?.paymentStatus ===
                                      "UNPAID"
                                        ? "UnPaid"
                                        : s?.paymentStatus ===
                                          "PAID"
                                        ? "Paid"
                                        : s?.paymentStatus}
                                    </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })):(
                               <div className="text-center p-3 text-muted">
            No status  history found for this booking.
        </div>)
                            )}
 
                       </div>
                      </div>
                   
                 
                  </div>
                </div>
              </div>
            </div>
              
          </div>
        </div>
      </div>
    </div>
  );
};

ViewInterest.propTypes = {
  onClose: PropTypes.func,
  isSelectedData: PropTypes.object,
};

export default ViewInterest;
  